/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrop11Filled = createReactComponent("filled", "crop-1-1-filled", "IconCrop11Filled", [["path", { "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconCrop11Filled as default };
//# sourceMappingURL=IconCrop11Filled.mjs.map
